export default "__VITE_ASSET__CRqRSI1V__"